var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#111","cx":"13.13","cy":"12.94","r":"13.25","key":0}),React.createElement("g",{"fill":"#1CBEFF","key":1},[React.createElement("path",{"d":"M17.243 7.924c-.5 0-.91.41-.91.91s.41.91.91.91.91-.41.91-.91-.4-.91-.91-.91zM13.193 9.094a3.83 3.83 0 1 0 3.83 3.83c-.01-2.11-1.72-3.83-3.83-3.83zm0 6.28c-1.35 0-2.45-1.1-2.45-2.45s1.1-2.45 2.45-2.45 2.45 1.1 2.45 2.45-1.1 2.45-2.45 2.45z","key":0}),React.createElement("path",{"d":"M16.233 20.694h-6.2c-2.58 0-4.66-2.09-4.67-4.67v-6.2c0-2.58 2.09-4.66 4.67-4.67h6.2c2.58 0 4.66 2.09 4.67 4.67v6.2a4.688 4.688 0 0 1-4.67 4.67zm-6.2-14.08c-1.77 0-3.2 1.44-3.2 3.21v6.2c0 1.77 1.44 3.2 3.2 3.21h6.2c1.77 0 3.2-1.44 3.2-3.21v-6.2c0-1.77-1.44-3.2-3.2-3.21h-6.2z","key":1})])]);
}

Instagram.defaultProps = {"viewBox":"0 0 26.5 26.5","xmlSpace":"preserve"};

module.exports = Instagram;

Instagram.default = Instagram;
